export default __webpack_public_path__ + "static/media/Ch1d.f7beb04c.gif";